module.exports = __webpack_public_path__ + "static/img/no_tvoc.8daf0830.png";